import { classNames, elements } from './init';

const setHighlightColorScheme = () => {
	elements.nav.setAttribute('data-color-scheme', 'highlight');
};

const removeHighlightColorScheme = () => {
	elements.nav.hasAttribute('data-color-scheme') && elements.nav.removeAttribute('data-color-scheme');
};

export const toggleHighlightColorScheme = () => {
	const navOnHighlightBG = elements.nav.classList.contains('nav--on-highlight');
	const desktopNav = !document.body.classList.contains(classNames.mobileDevice) && window.innerWidth > 1200;
	const notScrolled = window.scrollY === 0;
	const noOpenStage = !document.body.classList.contains(classNames.stageOpen);

	removeHighlightColorScheme();
	navOnHighlightBG && desktopNav && notScrolled && noOpenStage && setHighlightColorScheme();
};
